/* HUSHLY — mur d'avis : onglets produit/boutique, tri, filtre, « voir plus ».
   Aucune dependance. Sans JS, la page reste utilisable : les avis produit sont
   deja visibles cote serveur, seuls le tri et les onglets deviennent inertes. */
(function () {
  function num(el, attr) { var v = parseInt(el.getAttribute(attr), 10); return isNaN(v) ? 0 : v; }

  function init(root) {
    if (root.hrwDone) return;
    root.hrwDone = true;
    var grid = root.querySelector('[data-hrw-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.hrw__card'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.hrw__tab'));
    var sortSel = root.querySelector('[data-hrw-sort]');
    var filtSel = root.querySelector('[data-hrw-filter]');
    var avgEl = root.querySelector('[data-hrw-avg]');
    var totEl = root.querySelector('[data-hrw-tot]');
    var none = root.querySelector('[data-hrw-none]');
    var moreWrap = root.querySelector('[data-hrw-more]');
    var moreBtn = root.querySelector('[data-hrw-morebtn]');
    var step = num(root, 'data-hrw-step') || 16;
    var scope = grid.getAttribute('data-scope') || 'product';
    var shown = step;

    cards.forEach(function (c, i) {
      c.hrwI = i;
      c.hrwStars = num(c, 'data-stars');
      c.hrwPhoto = c.getAttribute('data-photo') === '1';
      c.hrwScope = c.getAttribute('data-scope') || 'product';
      c.classList.remove('is-over');
    });

    function current() {
      var list = cards.filter(function (c) { return c.hrwScope === scope; });
      var f = filtSel ? filtSel.value : 'all';
      if (f === 'photo') list = list.filter(function (c) { return c.hrwPhoto; });
      else if (f !== 'all') list = list.filter(function (c) { return c.hrwStars === parseInt(f, 10); });
      var s = sortSel ? sortSel.value : 'recent';
      /* 26/09/2026 : « Photos first » (resume de note de la fiche) */
      if (s === 'photo') list.sort(function (a, b) { return (b.hrwPhoto ? 1 : 0) - (a.hrwPhoto ? 1 : 0) || a.hrwI - b.hrwI; });
      else if (s === 'high') list.sort(function (a, b) { return b.hrwStars - a.hrwStars || a.hrwI - b.hrwI; });
      else if (s === 'low') list.sort(function (a, b) { return a.hrwStars - b.hrwStars || a.hrwI - b.hrwI; });
      else if (s === 'old') list.sort(function (a, b) { return b.hrwI - a.hrwI; });
      else list.sort(function (a, b) { return a.hrwI - b.hrwI; });
      return list;
    }

    function render() {
      var list = current();
      var keep = [];
      cards.forEach(function (c) { c.hidden = true; });
      var frag = document.createDocumentFragment();
      list.forEach(function (c, i) { if (i < shown) c.hidden = false; keep.push(c); frag.appendChild(c); });
      cards.forEach(function (c) { if (keep.indexOf(c) < 0) frag.appendChild(c); });
      grid.appendChild(frag);
      grid.setAttribute('data-scope', scope);
      if (none) none.hidden = list.length > 0;
      if (moreWrap) moreWrap.hidden = list.length <= shown;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var next = t.getAttribute('data-scope') || 'product';
        if (next === scope) return;
        scope = next;
        shown = step;
        tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (avgEl && avgEl.getAttribute('data-' + scope)) avgEl.textContent = avgEl.getAttribute('data-' + scope);
        if (totEl && totEl.getAttribute('data-' + scope)) totEl.textContent = totEl.getAttribute('data-' + scope);
        render();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { shown = step; render(); });
    if (filtSel) filtSel.addEventListener('change', function () { shown = step; render(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += step; render(); });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-hrw]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
